module.exports = __webpack_public_path__ + "img/smart-music-pilot_flow.68e2a216.png";